import React from 'react';
import { Row, Col, Card, CardBody, Label, Input, Button } from 'reactstrap';

const ReportFilters = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  onFilter,
}) => {
  return (
    <Card className="mb-4">
      <CardBody>
        <Row>
          <Col md={3}>
            <Label for="dashStartDate">Fecha inicio</Label>
            <Input
              type="date"
              id="dashStartDate"
              value={startDate}
              onChange={(e) => onStartChange(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Label for="dashEndDate">Fecha fin</Label>
            <Input
              type="date"
              id="dashEndDate"
              value={endDate}
              onChange={(e) => onEndChange(e.target.value)}
            />
          </Col>
          <Col md={3} className="d-flex align-items-end">
            <Button color="primary" onClick={onFilter}>
              Filtrar
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ReportFilters;
